import { Controller } from "@hotwired/stimulus"

// A "back" link that goes to the previous page when there is one in this tab,
// and follows its href (a sensible fallback) when the tab opened on this page.
export default class extends Controller {
  go(event) {
    if (window.history.length <= 1) return

    event.preventDefault()
    window.history.back()
  }
}
